import { parametroTypes } from "../../types/parametroTypes";
import { parametroState } from "../../states/parametroState";

export const tipoDocumentoReducer = ( state = parametroState, action ) => {
    switch ( action.type ) {
		case parametroTypes.TIPO_DOCUMENTO_RESET:
            return { ...state, isLoading: false, listado: [] };

		case parametroTypes.TIPO_DOCUMENTO_GET_START:
            return { ...state, isLoading: true, listado: action.payload };

		case parametroTypes.TIPO_DOCUMENTO_GET_COMPLETE:
            return { ...state, isLoading: false, message: 'Se buscó con éxito', severity: 'success', listado: action.payload };
            
        case parametroTypes.TIPO_DOCUMENTO_GET_ERROR:
            return { ...state, isLoading: false, listado: action.payload };

        default:
            return { ...state };
    }
}


export const tipoInstEduReducer = ( state = parametroState, action ) => {
    switch ( action.type ) {
		case parametroTypes.TIPO_INST_EDU_RESET:
            return { ...state, isLoading: false, listado: [] };

		case parametroTypes.TIPO_INST_EDU_GET_START:
            return { ...state, isLoading: true, listado: action.payload };

		case parametroTypes.TIPO_INST_EDU_GET_COMPLETE:
            return { ...state, isLoading: false, message: 'Se buscó con éxito', severity: 'success', listado: action.payload };
            
        case parametroTypes.TIPO_INST_EDU_GET_ERROR:
            return { ...state, isLoading: false, listado: action.payload };

        default:
            return { ...state };
    }
}


export const nacionalidadReducer = ( state = parametroState, action ) => {
    switch ( action.type ) {
		case parametroTypes.NACIONALIDAD_RESET:
            return { ...state, isLoading: false, listado: [] };

		case parametroTypes.NACIONALIDAD_GET_START:
            return { ...state, isLoading: true, listado: action.payload };

		case parametroTypes.NACIONALIDAD_GET_COMPLETE:
            return { ...state, isLoading: false, message: 'Se buscó con éxito', severity: 'success', listado: action.payload };
            
        case parametroTypes.NACIONALIDAD_GET_ERROR:
            return { ...state, isLoading: false, listado: action.payload };

        default:
            return { ...state };
    }
}
